import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import { combineClasses } from 'wanderu-css';

import ListPart from '../ListPart/ListPart';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ListAdornment.scss';

function ListAdornment(props) {
    const {
        classes: classesProp = {},
        className,
        size = 'auto',
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProp);

    return (
        <ListPart
            className={clsx(
                classes.root,
                {
                    [classes[`size-${size}`]]: size !== 'auto',
                },
                className,
            )}
            {...otherProps}
        />
    );
}

ListAdornment.propTypes = {
    /**
     * Sets the align-self property to control the vertical positioning
     */
    align: PropTypes.oneOf(['center', 'end', 'start']),
    /**
     * The content of the list adornment.
     */
    children: PropTypes.node,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * Sets the justify-content property to control the horizontal positioning
     */
    justify: PropTypes.oneOf(['center', 'end', 'start']),
    /**
     * Defines the size allocated to the adorment.
     * Auto will fit to the size of the cotent.
     * Values 0-10 will apply a width of n * the base spacing size
     */
    size: PropTypes.oneOf(['auto', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
};

export default ListAdornment;
